import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axiosConfig"; // Ensure this imports your axios instance
import { toast } from "react-toastify";
// 🟢 NEW: Import Auth Context
import { useAuth } from "./AuthContext";

const EmployeeContext = createContext();

export const useEmployees = () => useContext(EmployeeContext);

export const EmployeeProvider = ({ children }) => {
  const [employees, setEmployees] = useState([]);
  
  // 🟢 NEW: Get the current user
  const { user } = useAuth();

  // 1. FETCH EMPLOYEES
  const fetchEmployees = async () => {
    try {
      const res = await api.get("/employees");
      setEmployees(res.data);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  useEffect(() => {
    if (!user || !user.id) {
      setEmployees([]); // Clear data if logged out
    }
  }, [user]);

  // 2. ADD EMPLOYEE
  const addEmployee = async (employeeData) => {
    try {
      const res = await api.post("/employees", employeeData);
      setEmployees((prev) => [res.data, ...prev]);
      // toast handled in form usually, or add here
    } catch (err) {
      toast.error("Failed to add employee");
    }
  };

  // 3. UPDATE EMPLOYEE
  const updateEmployee = async (updatedData) => {
    try {
      await api.put(`/employees/${updatedData.id}`, updatedData);
      setEmployees((prev) =>
        prev.map((emp) => (String(emp.id) === String(updatedData.id) ? updatedData : emp))
      );
    } catch (err) {
      toast.error("Failed to update employee");
    }
  };

  // 4. DELETE EMPLOYEE
  const deleteEmployee = async (id) => {
    try {
      await api.delete(`/employees/${id}`);
      setEmployees((prev) => prev.filter((emp) => String(emp.id) !== String(id)));
    } catch (err) {
      toast.error("Failed to delete employee");
    }
  };

  const getEmployeeById = (id) => {
    return employees.find(e => String(e.id) === String(id));
  };

  return (
    <EmployeeContext.Provider
      value={{
        employees,
        addEmployee,
        updateEmployee,
        deleteEmployee,
        getEmployeeById,
        fetchEmployees,
      }}
    >
      {children}
    </EmployeeContext.Provider>
  );
};